<template>
  <div class="com_left_side">
    <Menu ref="menu" :accordion="true" @on-select="handleSelect" @on-open-change="handleOpenChange"
      :open-names="openNames" :active-name="activeName">
      <Submenu :name="item.path" v-for="(item, i) in menus" :key="i">
        <template slot="title">
          <i :class="['menu-icon menu-icon-menu', { 'menu-icon-active': activeName.includes('/') }]"></i>
          {{ item.title }}
        </template>
        <MenuItem v-for="(child, j) in item.children" :key="j" :title="child.title" :name="'/' + child.path">
        <span class="circular"></span>
        {{ child.title }}
        </MenuItem>
        <!-- <Submenu :name="child.path"
              v-if="item.children && item.children.length"
              v-for="(child, cI) in item.children"
              :key="cI">
              <MenuItem v-for="(child, j) in item.children"
                        v-if="$auth.hasPermission(child.code)"
                        :key="j"
                        :title="child.title"
                        :name="item.path + '/' + child.path"
              >
                <span class="circular"></span>
                {{ child.title }}
              </MenuItem>
            </Submenu> -->
      </Submenu>
    </Menu>
  </div>
</template>

<script>

export default {
  name: 'LeftSide',
  data() {
    return {
      activeName: '/',
      openNames: [],
      menus: [
        {
          title: '用户管理',
          path: '',
          children: [
            {
              title: '用户管理配置',
              path: 'user-config',
              code: 'userM-look',
            },
            {
              title: '组织管理',
              path: 'organ-management',
              code: 'userM-look',
            },
            {
              title: '角色管理',
              path: 'role',
              code: 'userM-look',
            },
          ]
        }
      ],
      list: []
    }
  },
  computed: {
  },
  watch: {
    '$route': {
      handler(n) {
        this.updateMenu();
      },
      immediate: true,
    },
  },
  methods: {
    // 更新菜单
    async updateMenu() {
      return;
      let [path1, path2, path3] = this.$route.path.split('/').slice(1);
      if (!path2 || !path3) {
        path2 = await this.menu[0]?.path;
        path3 = await this.menu[0]?.children[0]?.path;
        path2 ? this.$router.push(`${path2}`) : '';
      }
      let { path, fullPath, meta, query } = this.$route;
      // 解决微前端面包屑高亮问题，存在左侧菜单高亮不正确未找到原因
      // if (meta.fullPath?.includes(query.comp)) {
      //   let pathArr = fullPath.split('/');
      //   path1 = pathArr[1];
      //   path2 = pathArr[pathArr.length - 1];
      // } else
      if (meta.noQuery && path !== fullPath) {
        this.activeName = '';
        this.openNames = [];
        return;
      }
      await this.$refs.menu;
      // setTimeout(() => {
      this.activeName = `${path3}`;
      this.openNames = [path2];
      console.log(this.activeName, this.openNames)
      
      this.$emit('openMenu');
      this.$nextTick(() => {
        this.$refs.menu?.updateActiveName();
        this.$refs.menu?.updateOpened();
      });
      // }, 100)
    },
    // 打开 & 关闭 菜单
    handleOpenChange(e) {
      if (!e) return;
      this.openNames = e;
      let arr = this.menus.filter((item) => {
        return item.code === e[0];
      });
      if (arr.length > 0 && !arr[0].children) {
        this.activeName = '';
        this.$refs.menu.currentActiveName = '';
        this.$router.push(arr[0].fullPath);
      }
    },
    // 选中菜单
    handleSelect(menuItemName) {
      let [path1, path2] = menuItemName.split('/');
      let arr1 = this.menus.filter((item) => {
        return item.path === path1;
      });
      let arr2 = [];
      if (arr1.length > 0) {
        arr2 = arr1[0].children && arr1[0].children.filter((item) => {
          return item.path === path2;
        });
      }
      // if (arr2[0].transit) {
      //   this.$router.push({
      //     path: '/transitPage',
      //     query: {
      //       path: `/${menuItemName}`
      //     }
      //   })
      // } else {
        console.log(menuItemName, 'menuItemName');
      this.$router.push(`${menuItemName}`);
      // }
      this.activeName = menuItemName;

      this.$emit('openMenu', {
        path: `${menuItemName}`,
        cps: 'LeftSide',
        name: arr2.length > 0 ? arr2[0]?.title : arr1[0]?.title,
      })
    },
    init() {
      this.updateMenu();
      console.log(this.activeName, this.$route.path, '---')
      if ((this.$route.path !== '/') || `/backstage/${this.activeName}` === this.$route.path) return;
      console.log('---in')
      if (this.menus[0]) {
        let path = `${this.menus[0]?.path}`;
        this.$router.push(path);
        this.activeName = this.$route.path;
        this.openNames = [this.menus[0]?.path];
        this.updateMenu();
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.init();
    })
  },
}
</script>

<style lang="less" scoped>
@left-main-color: #1a45b8;

.menu-icon() {
  width: 23px;
  height: 20px;
  margin-right: 5px;
  background-size: contain;

  &.menu-icon-menu {
    background-image: url("~_img/nav/icon.png") !important;
  }
}

.menu-icon-active() {
  width: 23px;
  height: 20px;
  margin-right: 5px;
  background-size: contain;

  &.menu-icon-menu {
    background-image: url("~_img/nav/icon-act.png") !important;
  }
}

.com_left_side {
  min-width: 250px;
  max-width: 250px;
  height: 100%;
  background: #fff;
  /*background: linear-gradient(180deg, #fff 0%, #e6eef8 100%);*/
  /*box-shadow: -2px 2px 10px rgba(255, 255, 255, .2), 2px 2px 10px rgba(0, 0, 0, .3);*/
  background: linear-gradient(180deg, #dee8f7 0%, #becfe8 100%);
  box-shadow: 0px 2px 19px 0px rgba(201, 208, 228, 0.58);
  position: relative;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 256px;
    background: url("~_img/nav/bg.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
    /*z-index: 999;*/
  }

  // 一级菜单
  /deep/ .ivu-menu.ivu-menu-vertical {
    background: transparent;
    border: 2px solid #fff;
    padding: 10px;
    height: 100%;

    &::after {
      display: none;
    }

    width: 100% !important;
    user-select: none;

    // 一级菜单 item
    .ivu-menu-submenu {

      // 展开样式
      &.ivu-menu-opened {
        .ivu-menu-submenu-title {
          font-size: 16px;
          /*font-weight: bold;*/
          // color: @left-main-color;
          // line-height: 21px;

          >i {
            &.ivu-icon-ios-arrow-down {
              right: 20px;

              &::before {
                /*content: "\F33D";*/
                color: @left-main-color;
              }
            }
          }
        }
      }

      /*高亮样式*/

      &.ivu-menu-child-item-active {
        .ivu-menu-submenu-title {
          font-size: 16px;
          font-weight: bold;
          color: @left-main-color;

          // 菜单图标 active
          .menu-icon {
            .menu-icon-active();
          }
        }
      }

      // 标题
      .ivu-menu-submenu-title {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #000;
        height: 48px;
        line-height: 48px;
        display: flex;
        align-items: center;
        padding: 0 10px 0 20px !important;

        &:hover {
          font-weight: bold;
          color: @left-main-color;

          >i {
            &.ivu-icon-ios-arrow-down {
              &::before {
                content: "\F33D";
                color: @left-main-color;
              }
            }
          }

          // 菜单图标 active
          .menu-icon {
            .menu-icon-active();
          }
        }

        >i {
          margin: 0;

          &.menu-icon {
            .menu-icon();
          }

          &.ivu-icon-ios-arrow-down {
            right: 4px;

            &::before {
              content: "" !important;
              /*content: "\F33D";*/
              width: 16px;
              height: 16px;
              color: #969fbc;
              background: url("~_img/nav/arrow-down.png") no-repeat;
              background-size: 100% 100%;
              position: absolute;
              right: 0;
              transform: translateY(-40%);
            }
          }
        }
      }

      // 二级菜单
      >.ivu-menu {
        background: #fff;
        box-shadow: 0px 2px 10px 0px rgba(201, 208, 228, 0.58);
        border-radius: 4px;
        // padding: 2px 0;
        position: relative;
        overflow: hidden;

        &::before {
          content: "";
          position: absolute;
          top: 3px;
          left: 3px;
          width: 3px;
          height: calc(100% - 6px);
          border-radius: 3px;
        }

        &:empty {
          padding: 0;
        }

        // 二级菜单 item
        .ivu-menu-item {
          // display: flex;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #333;
          line-height: 40px;
          height: 40px;
          padding: 0 20px !important;
          padding-left: 45px !important;
          width: 100%;
          text-align: left;
          .ellipsis();

          .circular {
            display: inline-block;
            width: 10px;
            height: 10px;
            background: #edeef3;
            box-shadow: 0 0 1px 0 #fff;
            margin-right: 10px;
            border-radius: 50%;
            position: relative;

            &::after {
              content: "";
              width: 5px;
              height: 5px;
              background: #949dbc;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
            }
          }

          &.ivu-menu-item-active:not(.ivu-menu-submenu) {
            border-radius: 1px;
            background: #fff;
            // filter: blur(0px);
            color: @left-main-color;
            position: relative;

            .circular {
              box-shadow: 0px 0px 1px 0px #fff,
                inset 0px 0px 2px 0px rgba(26, 69, 184, 0.4);

              &::after {
                background: @left-main-color;
              }
            }

            &::after {
              display: none;
            }
          }

          &:hover:not(.ivu-menu-item-disabled) {
            // color: @main-color;
          }

          &.ivu-menu-item-disabled {
            cursor: default;
            opacity: 0.5;
          }
        }
      }

      &.no-child {
        >.ivu-menu {
          display: none;
        }

        .ivu-icon {
          display: none;
        }
      }
    }

    // 只是一级菜单
    .menu-item-no-child {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #000;
      height: 48px;
      line-height: 48px;
      display: flex;
      align-items: center;
      padding: 0 10px 0 20px !important;
      cursor: pointer;

      &:hover {
        font-weight: bold;
        color: @left-main-color;
        // text-shadow: 0px 0px 6px rgba(255, 255, 255, 0.38),
        //   0px 2px 4px rgba(0, 0, 0, 0.5);
        // 菜单图标 hover
        // .menu-icon {
        //   &.menu-icon-menu {
        //     background-image: url("~_img/app-left/menu.png") !important;
        //   }
        // }
        // .menu-icon();
      }

      >i {
        margin: 0;
        // 菜单图标 normal
        // &.menu-icon {
        //   // margin-right: 28px;
        //   width: 34px;
        //   height: 34px;
        //   display: inline-block;
        //   background-repeat: no-repeat;
        //   background-size: 34px 34px;
        //   &.menu-icon-menu {
        //     background-image: url("~_img/app-left/menu.png") !important;
        //   }
        // }
        .menu-icon();

        &.ivu-icon-ios-arrow-down {
          right: 14px;

          &::before {
            content: "\F33D";
          }
        }
      }
    }
  }
}
</style>